<template>
  <div class="wrap">
  
  </div>
</template>

<script>
export default {
  name: 'orderPay',
  components: {
    //
  },
  setup() {

    return {
      //
    }
  },
}
</script>

<style></style>
